import { useEffect, useState } from "react";

import './Typing.css'

export default function Typing({ text, speed = 50, className }) {
    const [texto, setTexto] = useState("");
    const [typing, setTyping] = useState()

    useEffect(() => {
        let index = 0;  
        const intervalo = setInterval(() => {
            setTexto(text.slice(0, index + 1));
            index++;
            
            if (index === text.length) {
                clearInterval(intervalo);
            }
        }, speed);
        
        return () => clearInterval(intervalo);
    }, [text, speed]);

    return (
        <h1 className={className}>
            {texto}
            <span className="cursor">|</span>
        </h1>
    );
}